import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Container, CssBaseline, ThemeProvider, Box } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import Navigation from './components/Navigation';
import Dashboard from './components/Dashboard';
import InvoiceForm from './components/InvoiceForm';
import InvoiceList from './components/InvoiceList';
import InvoiceDetail from './components/InvoiceDetail';
import CustomerSearch from './components/CustomerSearch';
import ErrorBoundary from './components/common/ErrorBoundary';
import theme from './theme/theme';

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Router>
            <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
              <Navigation />
              <Container 
                maxWidth="xl" 
                sx={{ 
                  mt: 4, 
                  mb: 4, 
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column'
                }}
              >
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/invoice/new" element={<InvoiceForm />} />
                  <Route path="/invoice/:id" element={<InvoiceDetail />} />
                  <Route path="/invoices" element={<InvoiceList />} />
                  <Route path="/customers" element={<CustomerSearch />} />
                  {/* Add a catch-all route for 404 */}
                  <Route path="*" element={
                    <Box sx={{ textAlign: 'center', py: 8 }}>
                      <h1>404 - Page Not Found</h1>
                      <p>The page you're looking for doesn't exist.</p>
                    </Box>
                  } />
                </Routes>
              </Container>
            </Box>
          </Router>
        </LocalizationProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
